module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=KZ - Kazakhstan.d63e33d1.svg";